module.exports = __webpack_public_path__ + "img/Al-Arasat2.98ff25f6.png";